<template>
  <v-card class="base-card shadow">
    <v-card-title class="headline accent--text pb-4"> Специальности </v-card-title>

    <v-card-text>
      <div
        v-for="(speciality, index) in specialities.list"
        :key="'position' + index"
      >
        <h3 class="my-4 pt-4">№ {{ index + 1 }}</h3>

        <CardAutocompleteRow
          v-model="speciality.speciality"
          :items="specialityList"
          item-value="id"
          :item-text="item => item.code + ' ' + item.name"
          label="Научная специальность"
          placeholder="Выберите научную специальность"
          return-object
          :disabled="isShowMode"
          :required="!isShowMode && !isNoRequiredFields"
          :no-filter="false"
          :error-messages="errorMessages[index].speciality"
          @input="
            $v.specialities.list.$each[index].speciality.$touch()
            updateSpeciality()
          "
        />

        <CardFieldRow
          v-model="speciality.scientificHeadName1"
          label="ФИО научного руководителя/консультанта 1"
          placeholder="Добавьте ФИО"
          :disabled="isShowMode"
          :error-messages="errorMessages[index].scientificHeadName1"
          @input="
            $v.specialities.list.$each[index].scientificHeadName1.$touch()
            updateSpeciality()
          "
        />

        <CardFieldRow
          v-model="speciality.scientificHeadName2"
          label="ФИО научного руководителя/консультанта 2"
          placeholder="Добавьте ФИО"
          hide-border-bottom
          :disabled="isShowMode"
          :error-messages="errorMessages[index].scientificHeadName2"
          @input="
            $v.specialities.list.$each[index].scientificHeadName2.$touch()
            updateSpeciality()
          "
        />

        <v-card-actions
          class="pt-2 pb-4 d-flex justify-end"
          v-if="specialities.list.length > 1 && !isShowMode"
        >
          <v-btn
            class="pa-0 mr-1 d-flex align-center simple-button simple-button__remove"
            color="red"
            :ripple="false"
            plain
            @click="removeSpeciality(index)"
          >
            <span class="btn-text">Удалить специальность</span>
          </v-btn>
        </v-card-actions>
      </div>
    </v-card-text>

    <v-card-actions
      class="px-6 pt-0 pb-4 d-flex justify-end"
      v-if="specialities.list.length < maxSpecialities && !isShowMode"
    >
      <v-btn
        class="pa-0 mr-1 d-flex align-center simple-button"
        color="primary"
        plain
        :ripple="false"
        @click="addSpeciality"
      >
        <span class="btn-text">Добавить специальность</span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import CardAutocompleteRow from '@/components/ui/row/CardAutocompleteRow'
import CardFieldRow from '@/components/ui/row/CardFieldRow'
import { SpecialityParent } from '@/models/Speciality'
import { maxLength, requiredIf } from 'vuelidate/lib/validators'
import { setValidateMessages } from '@/scripts/validation'
import { mapGetters } from 'vuex'

export default {
  components: {
    CardFieldRow,
    CardAutocompleteRow
  },
  props: {
    isShowMode: Boolean,
    selectedItem: Object,
    maxSpecialities: {
      type: Number,
      default: 999
    },
    isNoRequiredFields: {
      type: Boolean,
      default: false
    }
  },

  created() {
    if (this.$route.params.id === '0') {
      this.specialities.add()
      this.$nextTick(() => {
        this.updateSpeciality()
      })
    }
  },

  mounted() {
    this.updateInvalid()
  },

  data: () => ({
    specialities: new SpecialityParent()
  }),

  validations() {
    return {
      specialities: {
        list: {
          $each: {
            speciality: { required: requiredIf(() => !this.isNoRequiredFields) },
            scientificHeadName1: { maxLength: maxLength(150) },
            scientificHeadName2: { maxLength: maxLength(150) }
          }
        }
      }
    }
  },

  computed: {
    ...mapGetters('dictionaries', ['specialityList']),

    errorMessages() {
      const allErrors = {}

      Object.keys(this.$v.specialities.list.$each.$params).forEach(listKey => {
        allErrors[listKey] = {}

        Object.keys(this.$v.specialities.list.$each[listKey].$params).forEach(key => {
          allErrors[listKey][key] = setValidateMessages(this.$v.specialities.list.$each[listKey][key])
        })
      })

      return allErrors
    }
  },

  methods: {
    updateInvalid() {
      this.$emit('updateInvalid', this.$v.$invalid)
    },

    addSpeciality() {
      this.specialities.add()
      this.$nextTick(() => {
        this.updateSpeciality()
      })
    },

    removeSpeciality(index) {
      this.specialities.list.splice(index, 1)
      this.$nextTick(() => {
        this.updateSpeciality()
      })
    },
    async updateSpeciality() {
      try {
        this.$emit('update:selected-item', new SpecialityParent(this.specialities?.list))
        this.updateInvalid()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка при обновлении')
        throw e
      }
    }
  },

  watch: {
    selectedItem: {
      immediate: true,
      deep: true,
      handler(val) {
        this.specialities = new SpecialityParent(val?.list)
        this.updateInvalid()
      }
    }
  }
}
</script>

<style scoped></style>
